import * as effects from 'redux-saga/effects';
import { IApplicationState } from '..';

import { Backend } from '../../Backend/Backend';
import { ICallState } from '../../Backend/Messages/callSuccess';
import { Logger } from '../../Utils/Logger';

import { isNullOrUndefined } from '../../Utils/Various';
import { saveFilters } from '../Search/Actions';
import { IUserState } from '../User/Types';

import {
  getPoliticalGroup,
  getPoliticalGroupSuccess,
  getPoliticalGroupError,
  getDashboard,
  getDashboardSuccess,
  buildColumns,
  buildDataHMS,
  buildDataPercent,
  buildDataMonthHMS,
  buildDataMonthPercent,
  getDashboardDetail,
  getDashboardDetailSuccess,
  getDashboardError,
  getDateCloture,
  getDateClotureSuccess,
  getAutocompleteEmission,
  getAutocompleteEmissionSuccess,
} from "./Actions";
import {
  IDashboardActionTypes,
  IDetail,
  IFilters,
  IFiltersDetail,
  IPoliticalGroup,
  IResults,
} from "./Types";

function* handleGetPoliticalGroup(
  action: ReturnType<typeof getPoliticalGroup>
) {
  const backend = Backend.getInstance();

  const res: ICallState = yield effects.apply(
    backend,
    backend.getPoliticalGroup,
    [action.payload[0], action.payload[1]] as any
  );
  if (res.status_code === 200) {
    if (res !== null) {
      yield effects.put(
        getPoliticalGroupSuccess(res.results as IPoliticalGroup[])
      );
    }
  } else {
    Logger.warn("Failed GetPoliticalGroup");
    yield effects.put(getPoliticalGroupError(res.results));
  }
}
function* handleGetDashboard(action: ReturnType<typeof getDashboard>) {
  const backend = Backend.getInstance();
  try {
    let filters: IFilters = action.payload;
    const user: IUserState = yield effects.select(
      (state: IApplicationState) => state.user
    );
    const res: any = yield effects.apply(backend, backend.getDashboard, [
      user.token,
      filters.media_ids,
      filters.program_type_ids,
      filters.program_editors_ids,
      filters.time_slot_start,
      filters.time_slot_end,
      filters.date_type,
      filters.date_start,
      filters.date_end,
      filters.program_name,
    ]);
    if (res !== null && res.status_code === 200) {
      yield effects.put(getDashboardSuccess(res.results as IResults));
      yield effects.put(
        saveFilters({
          media_ids: filters.media_ids,
          media_str: filters.media_str,
          program_types_ids: filters.program_type_ids,
          program_types_str: filters.program_type_str,
          start_date: filters.date_start,
          end_date: filters.date_end,
        })
      );
      if (res.results.length !== 0) {
        yield effects.put(buildColumns());
        if (filters.date_type === "month" || filters.date_type === "calendar") {
          yield effects.put(buildDataMonthHMS());
          yield effects.put(buildDataMonthPercent());
        } else {
          yield effects.put(buildDataHMS());
          yield effects.put(buildDataPercent());
        }
      }
    } else {
      Logger.warn("Failed GetDashboard");
    }
  } catch (err) {
    Logger.warn({ err }, "Failed getDashboard");
    yield effects.put(getDashboardError(err));
    alert(err.message);
  }
}

function* handleGetDateCloture(action: ReturnType<typeof getDateCloture>) {
  const backend = Backend.getInstance();
  let token = action.payload;
  try {
    const res = yield effects.apply(backend, backend.getDateCloture, [token]);

    if (!isNullOrUndefined(res)) {
      const backendDate = new Date(res.results);
      const now = new Date();
      const chosen = backendDate > now ? now : backendDate;

      yield effects.put(getDateClotureSuccess(chosen));
    }
  } catch (err) {
    Logger.warn({ err }, "Failed getDateCloture");
  }
}
function* handleGetDashboardDetail(
  action: ReturnType<typeof getDashboardDetail>
) {
  const backend = Backend.getInstance();
  try {
    let filters: IFiltersDetail = action.payload;
    const res: ICallState = yield effects.apply(
      backend,
      backend.getDashboardDetail,
      [filters]
    );
    if (res.status_code === 200) {
      if (res !== null) {
        yield effects.put(getDashboardDetailSuccess(res.results as IDetail[]));
      }
    } else {
      Logger.warn("Failed getDashboardDetail");
      //yield effects.put(getDashboardError(res.results));
    }
  } catch (err) {
    Logger.warn({ err }, "Failed getDashboard");
  }
}
function* handleGetEmissionAutocomplete(
  action: ReturnType<typeof getAutocompleteEmission>
) {
  const backend = Backend.getInstance();

  const { emission_name, media_ids } = action.payload as {
    emission_name: string;
    media_ids?: number[];
  };

  // Toujours utiliser le nouvel endpoint avec media_ids si fourni
  // Sinon, utiliser l'endpoint classique (fallback)
  let res: ICallState;
  if (media_ids && media_ids.length > 0) {
    res = yield effects.apply(backend, backend.getAutocompleteEmissionByMedia, [
      emission_name,
      media_ids,
    ]);
  } else {
    res = yield effects.apply(backend, backend.getAutocompleteEmission, [
      emission_name,
    ]);
  }

  if (res.status_code === 200) {
    if (res !== null) {
      yield effects.put(getAutocompleteEmissionSuccess(res.results));
    }
  } else {
    Logger.warn("Failed handleGetEmissionAutocomplete");
  }
}

function* watchDashboard() {
  yield effects.takeEvery(
    IDashboardActionTypes.GET_POLITICAL_GROUP,
    handleGetPoliticalGroup
  );
  yield effects.takeEvery(
    IDashboardActionTypes.GET_DASHBOARD,
    handleGetDashboard
  );
  yield effects.takeEvery(
    IDashboardActionTypes.GET_DASHBOARD_DETAIL,
    handleGetDashboardDetail
  );
  yield effects.takeEvery(
    IDashboardActionTypes.GET_DATE_CLOTURE,
    handleGetDateCloture
  );
  yield effects.takeEvery(
    IDashboardActionTypes.GET_EMISSION_AUTOCOMPLETE,
    handleGetEmissionAutocomplete
  );
}

export function* DashboardSaga() {
    yield effects.all([
        effects.fork(watchDashboard),
    ]);
}
